// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

import { useSafeClientContext } from '@safecoin/dapp-kit';
import { KioskClient } from '@safecoin/kiosk';
import { createContext, useMemo, type ReactNode } from 'react';

export const KioskClientContext = createContext<KioskClient | null>(null);

export type KioskClientProviderProps = {
	children: ReactNode;
};

export function KioskClientProvider({ children }: KioskClientProviderProps) {
	const { client, network } = useSafeClientContext();
	// Kiosk resolves its per-network rule packages from the plain network name; networks it
	// has no entry for simply get no built-in rules (the old Network.CUSTOM behaviour).
	const kioskClient = useMemo(
		() => new KioskClient({ client, network: network.toLowerCase() }),
		[client, network],
	);
	return <KioskClientContext.Provider value={kioskClient}>{children}</KioskClientContext.Provider>;
}
